import { SearchMatchType } from '@aibees/elephant/types';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function certificationFilterConfig(): SearchFilterBase {
  return {
    name: 'Certification',
    icon: 'verified',
    index: 27,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.CONTACT_DATA],
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Certification',
        },
      },
    },
    pinned: true,
    sections: { main: 2, more: 1 },
    items: [
      {
        index: 0,
        type: SearchFilterType.GROUP_WRAPPER,
        sections: { main: 2, more: 1 },
        name: '',
        icon: undefined,
        metadata: {},
        items: [
          {
            name: 'Include',
            type: SearchFilterType.TEXT_FIELD,
            icon: undefined,
            index: 0,
            exactMatch: {
              enabled: true,
              default: SearchMatchType.SMART,
            },
            key: 'include_certification',
            field: 'include_certification',
            metadata: {
              color: 'primary',
              placeholder: 'Enter Certificate Name, (OR) Search',
              singleEntry: true,
            },
            open: true,
            layer: 3,
          },
          {
            name: 'Exclude',
            type: SearchFilterType.TEXT_FIELD,
            icon: undefined,
            index: 1,
            exactMatch: {
              enabled: true,
              default: SearchMatchType.SMART,
            },
            key: 'exclude_certification',
            field: 'exclude_certification',
            metadata: {
              color: 'error',
              icon: 'block',
              placeholder: 'Enter Certificate Name, (OR) Search',
              singleEntry: true,
            },
            open: true,
            layer: 3,
          },
          {
            name: 'Include (AND)',
            type: SearchFilterType.TEXT_FIELD,
            icon: undefined,
            index: 3,
            exactMatch: {
              enabled: true,
              default: SearchMatchType.SMART,
            },
            key: 'all_of_certification',
            field: 'all_of_certification',
            metadata: {
              color: 'warning',
              icon: 'add-task',
              placeholder: 'Enter Certificate Name, (AND) Search',
              singleEntry: true,
            },
            open: true,
            layer: 3,
          },
        ],
      },
    ],
  };
}
